import React, { useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon, MailIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="fixed top-0 left-0 right-0 w-full bg-black/40 backdrop-blur-sm shadow-sm z-50" data-id="element-184">
      <div className="container mx-auto px-4 w-full" data-id="element-185">
        {/* Main header with logo, navigation, and contact info */}
        <div className="hidden lg:flex items-center justify-between py-3 gap-6 w-full" data-id="element-186">
          {/* Logo and Title */}
          <div className="flex items-center flex-shrink-0" data-id="element-187">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uPFpggHPzcmoKqW3YEzkT4/KGI-logo.png" alt="KGI - Koda Group Inc." className="h-16 w-16 mr-3" data-id="element-188" />
            <div data-id="element-189">
              <h1 className="text-2xl font-serif font-bold text-white drop-shadow-lg leading-tight" data-id="element-190">
                Koda Group Inc.
              </h1>
              <p className="text-sm text-white/90 drop-shadow" data-id="element-191">
                Private Investigations & Security Services
              </p>
            </div>
          </div>
          {/* Navigation Menu */}
          <nav className="flex-shrink-0" data-id="element-192">
            <ul className="flex space-x-6" data-id="element-193">
              <li data-id="element-194">
                <a href="#" className="text-white font-semibold hover:text-kgi-red transition duration-200 drop-shadow" data-id="element-195">
                  Home
                </a>
              </li>
              <li data-id="element-196">
                <a href="#services" className="text-white/90 font-medium hover:text-kgi-red transition duration-200 drop-shadow" data-id="element-197">
                  Services
                </a>
              </li>
              <li data-id="element-198">
                <a href="#about" className="text-white/90 font-medium hover:text-kgi-red transition duration-200 drop-shadow" data-id="element-199">
                  About
                </a>
              </li>
              <li data-id="element-200">
                <a href="#" className="text-white/90 font-medium hover:text-kgi-red transition duration-200 drop-shadow" data-id="element-201">
                  Case Intake
                </a>
              </li>
              <li data-id="element-202">
                <a href="#contact" className="text-white/90 font-medium hover:text-kgi-red transition duration-200 drop-shadow" data-id="element-203">
                  Contact Us
                </a>
              </li>
            </ul>
          </nav>
          {/* Client Login Button */}
          <a href="#" className="flex-shrink-0 bg-kgi-red hover:bg-kgi-red-600 text-white text-sm font-bold py-2 px-5 rounded transition duration-300" data-id="element-204">
            Client Login
          </a>
          {/* Contact Info */}
          <div className="flex flex-col gap-1.5 flex-shrink-0" data-id="element-205">
            <a href="mailto:info@koda-is.com" className="flex items-center text-white/90 text-sm font-medium hover:text-kgi-red transition duration-200" data-id="element-206">
              <MailIcon className="h-4 w-4 mr-1.5" data-id="element-207" />
              info@koda-is.com
            </a>
            <a href="tel:3138446179" className="flex items-center text-white/90 text-sm font-medium hover:text-kgi-red transition duration-200" data-id="element-208">
              <PhoneIcon className="h-4 w-4 mr-1.5" data-id="element-209" />
              313-844-6179
            </a>
          </div>
        </div>
        {/* Mobile header */}
        <div className="flex lg:hidden justify-between items-center py-3 w-full" data-id="element-210">
          {/* Logo and Title */}
          <div className="flex items-center" data-id="element-211">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uPFpggHPzcmoKqW3YEzkT4/KGI-logo.png" alt="KGI - Koda Group Inc." className="h-16 w-16 mr-3" data-id="element-212" />
            <div data-id="element-213">
              <h1 className="text-xl font-serif font-bold text-white drop-shadow-lg leading-tight" data-id="element-214">
                Koda Group Inc.
              </h1>
              <p className="text-sm text-white/90 drop-shadow" data-id="element-215">
                Private Investigations & Security Services
              </p>
            </div>
          </div>
          {/* Mobile menu button */}
          <button onClick={toggleMenu} className="text-white hover:text-kgi-red" data-id="element-216">
            {isMenuOpen ? <XIcon className="h-9 w-9" strokeWidth={2.5} data-id="element-217" /> : <MenuIcon className="h-9 w-9" strokeWidth={2.5} data-id="element-218" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="lg:hidden pb-4 bg-black/60 backdrop-blur-md -mx-4 px-4 rounded-b-lg" data-id="element-219">
            <ul className="flex flex-col space-y-2" data-id="element-220">
              <li data-id="element-221">
                <a href="#" className="block py-2 text-white font-semibold" data-id="element-222">
                  Home
                </a>
              </li>
              <li data-id="element-223">
                <a href="#services" className="block py-2 text-white/90 font-medium hover:text-kgi-red" data-id="element-224">
                  Services
                </a>
              </li>
              <li data-id="element-225">
                <a href="#about" className="block py-2 text-white/90 font-medium hover:text-kgi-red" data-id="element-226">
                  About
                </a>
              </li>
              <li data-id="element-227">
                <a href="#" className="block py-2 text-white/90 font-medium hover:text-kgi-red" data-id="element-228">
                  Case Intake
                </a>
              </li>
              <li data-id="element-229">
                <a href="#contact" className="block py-2 text-white/90 font-medium hover:text-kgi-red" data-id="element-230">
                  Contact Us
                </a>
              </li>
            </ul>
            <div className="flex flex-col space-y-2 mt-4 pt-4 border-t border-white/20" data-id="element-231">
              <a href="mailto:info@koda-is.com" className="flex items-center text-white font-medium hover:text-kgi-red" data-id="element-232">
                <MailIcon className="h-4 w-4 mr-2" data-id="element-233" />
                info@koda-is.com
              </a>
              <a href="tel:3138446179" className="flex items-center text-white font-medium hover:text-kgi-red" data-id="element-234">
                <PhoneIcon className="h-4 w-4 mr-2" data-id="element-235" />
                313-844-6179
              </a>
              <a href="#" className="bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-2 px-4 rounded transition duration-300 text-center mt-2" data-id="element-236">
                Client Login
              </a>
            </div>
          </nav>}
      </div>
    </header>;
};